/* Wisselt de foto's en tekst van de twee sfeerrijen op de productpagina
   wanneer de bezoeker een andere variant (afwerking) kiest, bijvoorbeeld
   glad naar gehamerd. Zelfde normalisatie- en detectiemechanisme als
   kopero-anatomie.js, zodat beide op precies dezelfde manier reageren op
   de variant-picker.

   De alt-tekst in de JSON is gelijk aan de kop boven de foto en noemt het
   product niet. De sectie zet de producttitel in data-alt-suffix; die komt
   er hier tussen haakjes achter, precies zoals bij het eerste renderen.

   5 september 2026: de sleutels in de JSON zijn Nederlands (glad, gehamerd),
   maar de variant-picker geeft de vertaalde waarde terug. Op kopero.pt zocht
   dit script dus naar "liso" in een kaart met "glad" en veranderde er niets:
   de sfeerrijen bleven op de eerste uitvoering staan. De gekozen waarde gaat
   nu eerst door de kaart die kopero-product-gallery in de pagina zet. */
/* var in plaats van class/const: de sectie sfeer en de sectie toon laden dit bestand allebei, en een tweede
   "class" met dezelfde naam gaf een SyntaxError in de console. init is idempotent (data-sfeer-initialized). */
var KoperoSfeerVariant = class KoperoSfeerVariant {
  constructor(root) {
    this.root = root;
    this.rows = [...root.querySelectorAll('[data-sfeer-row]')];
    this.productHandle = root.dataset.productHandle;
    this.altSuffix = root.dataset.altSuffix || '';
    this.variantCopy = this.parseVariantCopy();

    if (!this.rows.length || !Object.keys(this.variantCopy).length) return;

    document.addEventListener('change', (event) => this.handleVariantInput(event));
  }

  parseVariantCopy() {
    try {
      return JSON.parse(this.root.querySelector('[data-sfeer-variant-copy]')?.textContent || '{}');
    } catch (error) {
      console.warn('Kopero sfeer-varianten konden niet worden geladen.', error);
      return {};
    }
  }

  normalizeVariant(value = '') {
    return value
      .toLocaleLowerCase('nl-NL')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  canoniek(sleutel) {
    try {
      const el = document.querySelector('[data-kopero-uitvoeringen]');
      if (!el) return sleutel;
      return JSON.parse(el.textContent || '{}')[sleutel] || sleutel;
    } catch (error) {
      return sleutel;
    }
  }

  handleVariantInput(event) {
    const picker = event.target.closest('variant-selects');
    if (!picker || picker.dataset.productHandle !== this.productHandle) return;

    const selected = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')]
      .map((group) => group.querySelector('input:checked, select')?.value)
      .filter(Boolean);

    if (selected.length) this.setVariant(this.canoniek(this.normalizeVariant(selected.join('-'))));
  }

  setVariant(variantKey) {
    const copy = this.variantCopy[variantKey];
    if (!copy) return;

    this.rows.forEach((row) => {
      const slot = row.dataset.sfeerRow;
      const img = row.querySelector('img');
      const video = row.querySelector('video');
      const kop = row.querySelector('h2');
      const tekst = row.querySelector('p');
      const beeld = copy[`beeld_${slot}`];
      const alt = copy[`alt_${slot}`];
      const film = copy[`film_${slot}`];
      const poster = copy[`poster_${slot}`];

      if (beeld && img) {
        if (img.hasAttribute('data-kopero-sfeer-src')) img.setAttribute('data-kopero-sfeer-src', beeld);
        else img.src = beeld;
      }
      if (alt && img) img.alt = this.altSuffix ? `${alt} (${this.altSuffix})` : alt;
      /* Een video wisselt alleen als de bron echt anders is: anders herstart
         hij (en dus het afspelen) bij elke change-event, ook wanneer de
         bezoeker een ander, niet-gerelateerd veld aanpast. */
      if (film && video && video.currentSrc.indexOf(film) === -1) {
        if (poster) video.setAttribute('poster', poster);
        video.src = film;
        video.load();
        video.muted = true;
        if (video.hasAttribute('data-kopero-visible-video')) {
          window.KoperoVideoVisibility.refresh();
        } else if (window.KoperoVideoVisibility.isVisible(video)) {
          const speel = video.play();
          if (speel && speel.catch) speel.catch(() => {});
        }
      }
      if (copy[`kop_${slot}`] && kop) kop.textContent = copy[`kop_${slot}`];
      if (copy[`tekst_${slot}`] && tekst) tekst.textContent = copy[`tekst_${slot}`];
    });
  }
};

var initKoperoSfeerVariant = (scope = document) => {
  scope.querySelectorAll('[data-kopero-sfeer]:not([data-sfeer-initialized])').forEach((root) => {
    root.dataset.sfeerInitialized = 'true';
    new KoperoSfeerVariant(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initKoperoSfeerVariant(), { once: true });
} else {
  initKoperoSfeerVariant();
}

document.addEventListener('shopify:section:load', (event) => initKoperoSfeerVariant(event.target));
